import { Button } from '@ophelos/ui/components/button';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from '@ophelos/ui/components/empty';
import { WifiOff } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { SettingsMenu } from '@/components/ui/SettingsMenu';
import { useAuth } from '@/contexts/customer-auth-context';
import { useTranslation } from '@/hooks/useTranslation';
import { usePreviewNavigate } from '@/hooks/usePreviewNavigate';

interface DashboardErrorPageProps {
  onRetry: () => void;
}

export function DashboardErrorPage({ onRetry }: DashboardErrorPageProps) {
  const { t } = useTranslation();
  const navigate = usePreviewNavigate();
  const { signOut } = useAuth();

  return (
    <Layout>
      <SettingsMenu className="absolute top-4 max-md:left-4 md:right-4 z-20" />
      <div className="flex h-screen items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon" className="mt-6 mb-8">
                <div className="p-4.5 border border-border-light/60 rounded-[3rem]">
                  <div className="p-4 border border-border-light/90 rounded-4xl">
                    <div className="p-3 border rounded-2xl">
                      <WifiOff />
                    </div>
                  </div>
                </div>
              </EmptyMedia>
              <EmptyTitle>{t('error.dataUnavailable.title')}</EmptyTitle>
              <EmptyDescription>{t('error.dataUnavailable.description')}</EmptyDescription>
              <div className="flex gap-2 mt-4">
                <Button onClick={onRetry}>{t('error.dataUnavailable.retry')}</Button>
                <Button variant="outline" onClick={async () => { await signOut(); navigate('/login'); }}>
                  {t('navigation.logout')}
                </Button>
              </div>
            </EmptyHeader>
          </Empty>
        </div>
      </div>
    </Layout>
  );
}
